/**
 * NESTAURA HEADER - ELEGANT SHOPIFY VERSION
 * Sophisticated interactions for high-value brand
 */

(function () {
  "use strict";

  let isMenuOpen = false;
  let menuToggle, overlay, mobileMenu;

  function initHeader() {
    console.log("🌟 Nestaura Elegant Header: Initializing...");

    // Get DOM elements
    menuToggle = document.querySelector(".nestaura-header__menu-toggle");
    overlay = document.querySelector(".nestaura-header__overlay");
    mobileMenu = document.querySelector(".nestaura-header__mobile-menu");

    if (!menuToggle || !mobileMenu) {
      console.error("❌ Required elements not found");
      return;
    }

    setupElegantInteractions();
    setupCartFunctionality();
    console.log("✨ Elegant header ready!");
  }

  function setupCartFunctionality() {
    const cartIcon = document.getElementById("cart-icon");
    const cartCount = document.getElementById("cart-count");

    if (cartIcon && cartCount) {
      // Update cart count display
      updateCartCount();

      // Add elegant cart icon interactions
      cartIcon.addEventListener("mouseenter", function () {
        cartIcon.style.transform = "scale(1.05)";
      });

      cartIcon.addEventListener("mouseleave", function () {
        cartIcon.style.transform = "scale(1)";
      });

      // Listen for cart updates (for future cart drawer integration)
      document.addEventListener("cart:updated", function (event) {
        updateCartCount(event.detail.item_count);
        animateCartBadge();
      });
    }
  }

  function updateCartCount(count) {
    const cartCount = document.getElementById("cart-count");
    if (cartCount) {
      const itemCount = count || parseInt(cartCount.textContent) || 0;
      cartCount.textContent = itemCount;

      if (itemCount > 0) {
        cartCount.classList.add("has-items");
      } else {
        cartCount.classList.remove("has-items");
      }
    }
  }

  function animateCartBadge() {
    const cartCount = document.getElementById("cart-count");
    if (cartCount) {
      cartCount.classList.add("bounce");
      setTimeout(() => {
        cartCount.classList.remove("bounce");
      }, 600);
    }
  }

  function setupElegantInteractions() {
    // Elegant hamburger interaction
    if (menuToggle) {
      menuToggle.addEventListener("click", handleElegantToggle);

      // Add sophisticated hover effects
      menuToggle.addEventListener("mouseenter", function () {
        if (!isMenuOpen) {
          menuToggle.style.transform = "translateY(-1px)";
          menuToggle.style.boxShadow = "0 8px 32px rgba(127, 255, 0, 0.2)";
        }
      });

      menuToggle.addEventListener("mouseleave", function () {
        if (!isMenuOpen) {
          menuToggle.style.transform = "translateY(0)";
          menuToggle.style.boxShadow = "0 8px 32px rgba(127, 255, 0, 0.15)";
        }
      });
    }

    // Overlay interaction
    if (overlay) {
      overlay.addEventListener("click", closeMenuElegantly);
    }

    // Escape key with elegance
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isMenuOpen) {
        closeMenuElegantly();
      }
    });

    // Elegant navigation link interactions
    const navLinks = document.querySelectorAll(
      ".nestaura-header__mobile-nav-link",
    );
    navLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        // Add elegant delay before closing
        setTimeout(closeMenuElegantly, 150);
      });

      // Sophisticated hover effects
      link.addEventListener("mouseenter", function () {
        link.style.transform = "translateX(8px)";
        link.style.boxShadow = "0 4px 20px rgba(0, 0, 0, 0.1)";
      });

      link.addEventListener("mouseleave", function () {
        link.style.transform = "translateX(0)";
        link.style.boxShadow = "none";
      });
    });

    // Elegant auth button interactions
    const authButtons = document.querySelectorAll(
      ".nestaura-header__mobile-btn",
    );
    authButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setTimeout(closeMenuElegantly, 150);
      });

      // Premium button hover effects
      button.addEventListener("mouseenter", function () {
        button.style.transform = "translateY(-2px)";
      });

      button.addEventListener("mouseleave", function () {
        button.style.transform = "translateY(0)";
      });
    });
  }

  function handleElegantToggle(e) {
    e.preventDefault();
    e.stopPropagation();

    // Add elegant haptic-like feedback
    menuToggle.style.transform = "scale(0.95)";
    setTimeout(() => {
      menuToggle.style.transform = "scale(1)";
    }, 100);

    if (isMenuOpen) {
      closeMenuElegantly();
    } else {
      openMenuElegantly();
    }
  }

  function openMenuElegantly() {
    console.log("🎭 Opening menu with elegance...");
    isMenuOpen = true;

    // Update hamburger state with sophistication
    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "true");
      menuToggle.style.transform = "translateY(0)";
      menuToggle.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.15)";
    }

    // Elegant overlay reveal
    if (overlay) {
      overlay.classList.add("active");
    }

    // Sophisticated menu reveal
    if (mobileMenu) {
      mobileMenu.classList.add("active");
    }

    // Prevent body scroll with elegance
    document.body.classList.add("nestaura-menu-open");
    document.body.style.transition = "all 0.3s cubic-bezier(0.23, 1, 0.32, 1)";

    console.log("✨ Menu opened elegantly");
  }

  function closeMenuElegantly() {
    console.log("🎭 Closing menu with elegance...");
    isMenuOpen = false;

    // Update hamburger state
    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.style.transform = "translateY(0)";
      menuToggle.style.boxShadow = "0 8px 32px rgba(127, 255, 0, 0.15)";
    }

    // Elegant menu hide
    if (mobileMenu) {
      mobileMenu.classList.remove("active");
    }

    // Sophisticated overlay hide
    if (overlay) {
      overlay.classList.remove("active");
    }

    // Restore body scroll elegantly
    document.body.classList.remove("nestaura-menu-open");

    console.log("✨ Menu closed elegantly");
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeader);
  } else {
    initHeader();
  }

  // Elegant debug function
  window.debugNestauraElegant = function () {
    console.log("🎭 NESTAURA ELEGANT HEADER DEBUG:");
    console.log("Menu Toggle:", menuToggle);
    console.log("Mobile Menu:", mobileMenu);
    console.log("Overlay:", overlay);
    console.log("Is Menu Open:", isMenuOpen);
    console.log("Body Classes:", document.body.className);
  };

  // Shopify theme editor support with elegance
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      if (event.detail.sectionId.includes("nestaura-header")) {
        setTimeout(initHeader, 100);
      }
    });

    document.addEventListener("shopify:section:unload", function (event) {
      if (event.detail.sectionId.includes("nestaura-header")) {
        if (isMenuOpen) {
          closeMenuElegantly();
        }
      }
    });
  }

  // Ensure clean header render without glitch
  window.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".nestaura-header");
    if (header) {
      // Ensure header is visible and positioned correctly from start
      header.style.transform = "translateY(0)";
      header.style.opacity = "1";
      header.style.position = "fixed";
      header.style.top = "0";
      header.style.zIndex = "999";
    }
  });
})();
